import { FC } from 'react';
import Box from '@mui/material/Box';
import { UI_TOKENS } from '../../../constants/designTokens';

/** The prototype's `ycSkel` pulse — grey100 bars fading between full and 45% opacity. */
const skelKeyframes = { '@keyframes ycSkel': { '0%': { opacity: 1 }, '50%': { opacity: 0.45 }, '100%': { opacity: 1 } } };

interface iSkeletonBarProps {
  width: number | string;
  height?: number;
  radius?: number;
}

export const SkeletonBar: FC<iSkeletonBarProps> = ({ width, height = 12, radius = 6 }) => (
  <Box
    aria-hidden
    sx={{
      width,
      height,
      borderRadius: `${radius}px`,
      bgcolor: UI_TOKENS.grey100,
      animation: 'ycSkel 1.5s ease-in-out infinite',
      flexShrink: 0,
      ...skelKeyframes,
    }}
  />
);

const QUEUE_COLUMN_WIDTHS = ['22%', '14%', '13%', '11%', '10%', '10%', '8%'];

/** Stands in for a list table while it loads. */
export const TableSkeleton: FC<{ rows?: number }> = ({ rows = 6 }) => (
  <Box role="status" aria-label="Loading" sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', flex: 1 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '24px', padding: '12px 20px' }}>
      {QUEUE_COLUMN_WIDTHS.map((width, j) => (
        <SkeletonBar key={j} width={`calc(${width} - 24px)`} height={10} />
      ))}
    </Box>
    {Array.from({ length: rows }, (_, i) => (
      <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: '24px', padding: '16px 20px', borderTop: `1px solid ${UI_TOKENS.divider}` }}>
        {QUEUE_COLUMN_WIDTHS.map((width, j) =>
          // The first column is text only — none of these tables shows a logo, so no avatar circle.
          j === 0 ? (
            <Box key={j} sx={{ width }}>
              <SkeletonBar width={110 + (i % 3) * 30} />
            </Box>
          ) : j === QUEUE_COLUMN_WIDTHS.length - 1 ? (
            <SkeletonBar key={j} width={64} height={22} radius={11} />
          ) : (
            <SkeletonBar key={j} width={`calc(${width} - 24px)`} />
          )
        )}
      </Box>
    ))}
  </Box>
);
